import React from 'react'
import styled from '@emotion/styled'
import Container from 'components/Container'
import IntegerInput from 'components/IntegerInput'
import { Bold, Slate, Faded } from 'components/Text'
import { Input, Form, color, spacer } from 'stylist'
import QuotaAutofill from './QuotaAutofill'
import QuotaTotals from './QuotaTotals'
import { noop } from 'utils'

const QuotaWrapper = styled(Container)`
  & {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 2fr 1fr 25%;
    grid-template-columns: 2fr 1fr 25%;
    -ms-grid-rows: auto auto auto auto;
    grid-template-rows: auto auto auto auto;
    grid-gap: 0;
    padding: 0;
    padding-bottom: ${spacer(4)};
  }
`

const CellBase = styled.div`
  padding: ${spacer(2)};
  display: flex;
  -ms-grid-row: ${props => props.msGridRow || 1};
`
const LeftCol = styled(CellBase)`
  -ms-grid-column: 1;
  grid-column: 1;
`
const MiddleCol = styled(CellBase)`
  border-width: 0 1px;
  border-style: solid;
  border-color: ${color('paleGrey')};
  text-align: center;
  justify-content: center;
  -ms-grid-column: 2;
  grid-column: 2;
`

const MiddleTopBottom = styled(MiddleCol)`
  padding-top: ${spacer(3)};
  padding-bottom: ${spacer(3)};
  background-color: ${color('paleGrey')};
`
const QuotaLimits = styled(MiddleTopBottom)`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`
const Totals = styled(MiddleTopBottom)`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`

const WhiteCellBase = styled.div`
  background-color: ${color('white')};
  box-shadow: inset 0 -1px 0 0 ${color('paleGrey')};
`
const WhiteLeftCol = WhiteCellBase.withComponent(LeftCol)
const WhiteMiddleCol = WhiteCellBase.withComponent(MiddleCol)

const SmallInput = styled(Input)`
  margin: auto;
  width: 100px;
`

const QuotaInput = styled(IntegerInput)`
  margin: auto;
  width: 100px;
`

/**
 * Provides a shared design for qualification/quota section.
 * @param {String} name qualification id e.g. 'gender'
 * @param {Array} options possible selections for the qualification
 * @param {Function} header function that returns the header component
 * @param {Function} row function that returns a row component
 * @param {Function} [footer] function that returns a footer row component
 */
const Wrapper = ({
  name,
  qualOptions,
  header,
  row,
  autofillDisabled = false,
  footer = noop,
  rowButton = noop
}) => (
  <QuotaWrapper>
    <LeftCol>{header()}</LeftCol>
    <QuotaLimits>
      <Bold>
        <Slate>Quotas/Limits</Slate> <Faded>(Optional)</Faded>
      </Bold>
    </QuotaLimits>
    {qualOptions.map((option, index) => (
      <Form.Field
        key={index}
        name={`quotas.${name}_quota${index}`}
        render={({ value: quota, setValue: setQuota }) => (
          <React.Fragment>
            <WhiteLeftCol msGridRow={index + 2}>
              {row(option, index, setQuota, quota)}
            </WhiteLeftCol>
            <WhiteMiddleCol msGridRow={index + 2}>
              {quota ? (
                <QuotaInput // Render when obj exists, avoid uncontrolled react error
                  name={`quotas.${name}_quota${index}.limit`}
                />
              ) : (
                <SmallInput disabled />
              )}
              {rowButton(index)}
            </WhiteMiddleCol>
          </React.Fragment>
        )}
      />
    ))}
    <LeftCol msGridRow={qualOptions.length + 2}>{footer()}</LeftCol>
    <Totals msGridRow={qualOptions.length + 2}>
      <QuotaTotals qualID={name} />
    </Totals>
    <QuotaAutofill disabled={autofillDisabled} qualID={name} />
  </QuotaWrapper>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QuotaWrapper.js